import { BRAND_CEL, BRAND_RCI } from 'contexts/CruiseSearchContext/constants';
import { BrandCode } from 'types';

export const TRACKING_ACTION = {
	INIT: 'init',
	SEARCH_UPDATE: 'searchUpdate',
	PAGINATION: 'pagination',
	SORT_CHANGE: 'sortByChange',
	INTERACTIONS: 'interactions',
	NAV_CLICKS: 'navClicks',
	INTERACTION: 'interaction',
};

export const TRACKING_FAVORITES_CEL = {
	WATCHLIST_CLICKED: 'watchlist_clicked',
	GO_TO_DASHBOARD: 'watchlist:search:go to dashboard',
	SIGN_IN_DISPLAYED: 'watchlist:sign in panel:displayed',
	SIGN_IN_PAGE: 'guestaccount:signin',
	ITINERARY_PAGE: 'itinerary-details',
	WATCHLIST_ADDED: 'watchlist:{0}:added',
	WATCHLIST_REMOVED: 'watchlist:{0}:removed',
	FAVORITES_CLICKED: 'favorites_clicked',
	FAVORITES_ADDED: 'favorites:{0}:added',
	FAVORITES_REMOVED: 'favorites:{0}:removed',
	FAVORITES_GO_TO_DASHBOARD: 'favorites:search:go to dashboard',
};

export const UTAG_VIEW = {
	AFFIRM: {
		CONTROL_OFF: 'affirm:control:off',
		EXPERIMENT_ACTIVATED: 'affirm:experiment:activated',
	},
	RECOMMENDED_SPLIT_EX: {
		CONTROL_OFF: 'sort:lowtohigh:control',
		EXPERIMENT_ACTIVATED: 'sort:recommended:experiment',
	},
};

export const TEALIUM_BRAND = {
	[BRAND_RCI.code]: {
		pageName: 'findacruise',
		pageType: 'findaCruise',
		siteSection: 'findacruise',
	},
	[BRAND_CEL.code]: {
		pageName: 'findacruise',
		pageType: 'findacruise',
		siteSection: 'findacruise',
	},
};

export const TRACKING_COMPARE = {
	COMPARE_PAGE: 'compare cruises',
	COMPARE_ADD: 'compareAdd',
	COMPARE_REMOVE: 'compareRemove',
	COMPARE_START: 'compareStart',
	EXPLORE_ITINERARY: 'compareExploreItinerary',
	WATCHLIST_ADDED: 'watchlistcompareadded',
	WATCHLIST_REMOVED: 'watchlistcompareremoved',
	SELECT_DATE: 'compareselectdate',
};

export const PROD_CATEGORY = {
	booking: 'Booking',
};

export const TRACKING = {
	country: '',
	currency: '',
	language: '',
	searchOption: '',
	pagination: '',
	targetedOfferFlag: '',
	groupId: '',
};

export const TRACKING_RCI = {
	pageName: TEALIUM_BRAND[BrandCode.RoyalCaribbean].pageName,
	pageType: TEALIUM_BRAND[BrandCode.RoyalCaribbean].pageType,
	siteSection: TEALIUM_BRAND[BrandCode.RoyalCaribbean].siteSection,
	cruiseSearchCurrency: '',
	cruiseSearchQuery: '',
	cruiseSearchType: 'Any',
	cruiseSearchDestCodes: 'Any',
	cruiseSearchShipPorts: 'Any',
	cruiseSearchMonths: 'Any',
	cruiseSearchPorts: 'Any',
	cruiseSearchNights: 'Any',
	cruiseSearchAdults: 'Any',
	cruiseSearchChildren: 'Any',
	cruiseSearchShipCodes: 'Any',
	cruiseSearchResults: 0,
	productEvent: '',
	prodCategory: '',
	prodSku: '',
	prodCost: '',
	cardPosition: '',
	csDepartureDate: '',
	prodQuantity: '',
	promoDashboard: '',
	splitEx: '',
};

export const TRACKING_CEL = {
	page_name: TEALIUM_BRAND[BrandCode.Celebrity].pageName,
	pageType: TEALIUM_BRAND[BrandCode.Celebrity].pageType,
	site_section: TEALIUM_BRAND[BrandCode.Celebrity].siteSection,
	Search_Type: 'open search text',
	search_destination: 'Any',
	search_departure_month: 'Any',
	search_departure_port: 'Any',
	search_num_nights: 'Any',
	cruiseSearchNumberOfGuests: 'Any',
	cruiseSearchGuestsChildren: 'Any',
	search_refine_ships: 'Any',
	search_cruise_ship_codes: 'Any',
	search_destinations_ports: 'Any',
	search_results: 0,
	product_event: '',
	sailing_date: '',
	prodCategory: '',
	product_sku: '',
	prodCost: '',
	card_position: '',
	prodQuantity: '',
	consumer_id: '',
	customer_ID: 0,
	captains_club_id: 0,
	Booking_Search_Details: 'Popular Cruise | Position',
	booking_options: 'none | none | none | 0000000 | none | none',
	cruise_dateToggle: 'M',
	cruise_package: 'cruisetours',
	link_name: '',
	logged_in: 0,
	new_search_results: 1,
	page_path: '/itinerary-search',
	page_section_type: 'cruise-search',
	search_cruise_package: 'CO,CT',
	search_departure_end_month: 'Any',
	search_refine_accessibility: 'none',
	search_refine_phrase: 'none',
	search_refine_room_types: 'CO,CT | none',
	search_refine_total_days: 'any',
	search_refine_total_guests: 'none',
	search_refine_total_refinements_qty: 0,
	search_sort_by: [],
	VDSID: 0,
};

export const INITIAL_TRACKING_BRAND = {
	[BRAND_RCI.code]: TRACKING_RCI,
	[BRAND_CEL.code]: TRACKING_CEL,
};

export const LOGIN_CAS_STATE = {
	SUCCESS: 'success',
	INVALID: 'error:invalid',
	TECHNICAL: 'error:technicalIssue',
};

export const TRACKING_INTERACTION = {
	TARGETED_OFFERS: {
		OFFER_APPLIED: 'cruiseSearch:targetedOffer:applied',
		OFFER_APPLIED_CASINO: 'cruiseSearch:casinoOffer:applied',
		OFFER_FLAG: 'applied',
		LOGIN_CAS_SUCCESS: 'CASlookup:success',
		LOGIN_EMAIL_SUCCESS: 'emailLookUp:success',
		LOGIN_CAS_INVALID: 'CASlookup:error:invalid',
		LOGIN_EMAIL_INVALID: 'emailLookUp:error:invalid',
		LOGIN_CAS_TECHNICAL: 'CASlookup:error:technicalIssue',
		LOGIN_EMAIL_TECHNICAL: 'emailLookUp:error:technicalIssue',
		LOOKUP_SUCCESS: 'targetedOfferLookup:success',
		LOOKUP_ERROR: 'targetedOfferLookup:error:001',
		FILTER_NORESULT: 'targetedOffer:noResult',
		USER_IDENTIFIED_CAS: 'targetedOffersOpened:userIdentifiedByCAS',
		USER_IDENTIFIED_EMAIL: 'targetedOffersOpened:userIdentifiedByEmail',
		PREFIX_CASINO: 'casino',
		EXPIRES_SOON: 'targetedOffers:myOffer:expiringSoon',
		EXPIRES_TODAY: 'targetedOffers:myOffer:expiringToday',
		MULTIPLE_EXPIRES: 'targetedOffers:expiringsoon',
		SOLD_OUT: 'targetedOffers:soldout',
		PILL_TARGETED_OFFERS_LOADED: 'targetedOffersAvailable',
		PILL_TARGETED_OFFERS_CLICK: 'targetedOffersOpened:UnKnown',
	},
	FAVORITES_AND_WATCHLIST: {
		CLICK_FAVORITE_HEADER: 'header:clicked:favorite',
		CLICK_FAVORITE_NAV: 'hamNav:favoritesandwatchlist',
		CLICK_NAV_FAVORITES: 'hamNav:favorites',
		CLICK_ADDED: 'Added',
		CLICK_REMOVED: 'Removed',
		CLICK_SEARCH_DASHBOARD: '{0}:search:gotodashboard',
		CLICK_FAVORITE_BUTTON_INTERACTION: 'favorites',
		CLICK_FAVORITE_BUTTON: 'favorited',
		CLICK_NAV_WATCHLIST: 'hamNav:watchlist',
		CLICK_WATCHLIST_BUTTON: 'watchlist',
		OPEN_WATCHLIST_MODAL: 'watchlist:signInPanel',
		FAVORITES_LIMIT_REACHED: 'favoritesReachedLimit',
		FAVORITES_SIGNIN_DISPLAYED: 'favorites:sign in panel:displayed',
	},
	AFFIRM_BANNER: {
		OPENED: 'affirm:opened',
		CLOSED: 'affirm:closed',
	},
	PAGINATION_CLICK: 'page {0} of {1}',
	SORT_CHANGE: 'cruise sort: {0}',
	PORTS: {
		CLICK_PORT_TAB: 'searchPanel:destinations:allPorts:clicked',
	},
	FILTERS: {
		NUMBER_GUEST: 'searchPanel:numberOfGuests:clicked',
	},
	COMPARE: {
		SELECT: 'compare: activate: select cruise',
		UNSELECT: 'compare: deactivate: unselect cruise',
		START: 'compare: start',
		CLOSE_COMPARISON: 'compare: close',
		REMOVE_CRUISE: 'compare: breadcrumb: remove',
		EXPLORE_FULL_ITINERARY: '{0} of {1}: {numberOfNights} night {cruiseTitle}: compare: explore itinerary',
		WATCHLIST_ADDED: 'cruise search : {0} of {1} : {numberOfNights} night {cruiseTitle}: watchlist:compare:added',
		WATCHLIST_REMOVED: 'cruise search : {0} of {1} : {numberOfNights} night {cruiseTitle}: watchlist:compare:removed',
		SELECT_DATE: 'cruise search : {0} of {1} : {numberOfNights} night {cruiseTitle}: watchlist:compare:selectDate',
	},
	RATING_AND_REVIEW: {
		OPENED_CARD_SEARCH: 'rating:cs:opened',
		OPENED_PRICING_VIEW: 'rating:pv:opened',
		RATING_VIEW_MORE: 'rating:viewMore:clicked',
	},
	SEARCH_ORIGIN: {
		SEARCH_WIDGET_INIT: 'search widget ',
		NL_SEARCH: 'open search text',
		FILTER_UPDATE: 'findacruise apply button search',
	},
};

export const TYPES_BANNER = {
	EXPIRES_SOON: 'expireSoon',
	EXPIRES_TODAY: 'expireToday',
	MULTIPLE_EXPIRES: 'multipleExpires',
	SOLD_OUT: 'soldOut',
};

export const INITIAL_SEARCH_OPTION = {
	SORT_DATE: 'cruise sort: date',
};

export const ANY = 'Any';
export const VDS_ID = 'VDS_ID';
